export function sortArticleImages<T extends { order?: number | null }>(
  images: T[]
) {
  return [...images].sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
}
